import React, { useEffect,useState } from "react";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import BankDatatables from "component/master/bank/BankDatatables";
import BankModalForm from "component/master/bank/BankModalForm";

function Bank() {
  const [modalMode, setModalMode] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bank, setBank] = useState([]);

  const fetchBank = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/bank`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
  
      if (!response.ok) throw new Error("Gagal mengambil data bank");
  
      const data = await response.json();
      setBank(data.data);
    } catch (error) {
      console.error("Error fetching bank:", error);
    }
  };

  useEffect(() => {
      document.title = "Green Hill Kemuning | Bank";
      window.scrollTo(0, 0);
      fetchBank();
  }, []);

  const handleAddBank = () => {
    setModalMode("add");
    setSelectedBank(null);
    setIsModalOpen(true);
  }

  const handleEditBank = (bank) => {
    setModalMode("edit");
    setSelectedBank(bank);
    setIsModalOpen(true);
  }

  const handleDeleteBank = async (bank) => {
    try {
      const confirmed = await showConfirm({
        title: 'Hapus Rekening',
        text: `Apakah Anda yakin ingin menghapus Rekening ${bank.name_rekening}?`,
        confirmButtonText: 'Hapus'
      });
      if (!confirmed) return;
  
      const response = await axios.delete(
        `${process.env.REACT_APP_API}/bank/${bank.bank_id}`
      );
  
      if (response.status === 200 || response.status === 201) {
        showSuccess(response.data.message || "Rekening berhasil dihapus");
        fetchBank();
      } else {
        showError(response.data.message || "Gagal menghapus Rekening");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      showError(error.response?.data?.message || "Terjadi kesalahan saat menghapus Rekening");
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  }
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Bank Management</h5>
                              <i className="bx bxs-plus-square" 
                                style={{ color: "blue", fontSize: 50, cursor: "pointer" }} 
                                onClick={handleAddBank}>
                              </i>
                            </div>
                            <BankDatatables data={bank} onEditBank={handleEditBank} onDeleteBank={handleDeleteBank}/>
                          </div>
                        </div>  
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>

      {isModalOpen && (
        <div className="modal fade show" style={{ display: "block" }}>
          <BankModalForm mode={modalMode} bankData={selectedBank} closeModal={closeModal} onSuccess={fetchBank}/>
        </div>
      )}        
    </div>
  );
}

export default Bank;
